/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { BulkLogInteractionPreview } from '../models/bulkLogInteractionPreview';

import type { BulkLogInteractionRequest } from '../models/bulkLogInteractionRequest';

import type { BulkLogInteractionResponse } from '../models/bulkLogInteractionResponse';

import type { CohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGetParams } from '../models/cohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGetParams';

import type { CohortActivityBreakdownResponse } from '../models/cohortActivityBreakdownResponse';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { InteractionCreate } from '../models/interactionCreate';

import type { InteractionListResponse } from '../models/interactionListResponse';

import type { InteractionResponse } from '../models/interactionResponse';

import type { InteractionTypeCreate } from '../models/interactionTypeCreate';

import type { InteractionTypeListResponse } from '../models/interactionTypeListResponse';

import type { InteractionTypeResponse } from '../models/interactionTypeResponse';

import type { InteractionTypeUpdate } from '../models/interactionTypeUpdate';

import type { InteractionUpdate } from '../models/interactionUpdate';

import type { ListContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGetParams } from '../models/listContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGetParams';

import type { ListInteractionTypesApiV1MasterDataContactsInteractionTypesGetParams } from '../models/listInteractionTypesApiV1MasterDataContactsInteractionTypesGetParams';

import type { ListInteractionsApiV1MasterDataContactsInteractionsGetParams } from '../models/listInteractionsApiV1MasterDataContactsInteractionsGetParams';

import type { ListOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGetParams } from '../models/listOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGetParams';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * The tenant's interaction vocabulary.

Every surface that RENDERS a logged interaction must pass `include_inactive=true`:
a retired type still labels the rows already logged under it, and an active-only
fetch cannot be un-filtered client-side (the `selectableRelationshipClasses`
lesson — the value is there, the option to label it is not, and the row renders
blank while nothing errors).
 * @summary List Interaction Types
 */
export const listInteractionTypesApiV1MasterDataContactsInteractionTypesGet = (
  params?: ListInteractionTypesApiV1MasterDataContactsInteractionTypesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<InteractionTypeListResponse>({
    url: `/api/v1/master-data/contacts/interaction-types`,
    method: 'GET',
    params,
    signal
  });
};

export const getListInteractionTypesApiV1MasterDataContactsInteractionTypesGetQueryKey =
  (
    params?: ListInteractionTypesApiV1MasterDataContactsInteractionTypesGetParams
  ) => {
    return [
      `/api/v1/master-data/contacts/interaction-types`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListInteractionTypesApiV1MasterDataContactsInteractionTypesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listInteractionTypesApiV1MasterDataContactsInteractionTypesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListInteractionTypesApiV1MasterDataContactsInteractionTypesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listInteractionTypesApiV1MasterDataContactsInteractionTypesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListInteractionTypesApiV1MasterDataContactsInteractionTypesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listInteractionTypesApiV1MasterDataContactsInteractionTypesGet
        >
      >
    > = ({ signal }) =>
      listInteractionTypesApiV1MasterDataContactsInteractionTypesGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listInteractionTypesApiV1MasterDataContactsInteractionTypesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListInteractionTypesApiV1MasterDataContactsInteractionTypesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listInteractionTypesApiV1MasterDataContactsInteractionTypesGet
      >
    >
  >;
export type ListInteractionTypesApiV1MasterDataContactsInteractionTypesGetQueryError =
  HTTPValidationError;

export function useListInteractionTypesApiV1MasterDataContactsInteractionTypesGet<
  TData = Awaited<
    ReturnType<
      typeof listInteractionTypesApiV1MasterDataContactsInteractionTypesGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListInteractionTypesApiV1MasterDataContactsInteractionTypesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInteractionTypesApiV1MasterDataContactsInteractionTypesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listInteractionTypesApiV1MasterDataContactsInteractionTypesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listInteractionTypesApiV1MasterDataContactsInteractionTypesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListInteractionTypesApiV1MasterDataContactsInteractionTypesGet<
  TData = Awaited<
    ReturnType<
      typeof listInteractionTypesApiV1MasterDataContactsInteractionTypesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListInteractionTypesApiV1MasterDataContactsInteractionTypesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInteractionTypesApiV1MasterDataContactsInteractionTypesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listInteractionTypesApiV1MasterDataContactsInteractionTypesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listInteractionTypesApiV1MasterDataContactsInteractionTypesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInteractionTypesApiV1MasterDataContactsInteractionTypesGet<
  TData = Awaited<
    ReturnType<
      typeof listInteractionTypesApiV1MasterDataContactsInteractionTypesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListInteractionTypesApiV1MasterDataContactsInteractionTypesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInteractionTypesApiV1MasterDataContactsInteractionTypesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Interaction Types
 */

export function useListInteractionTypesApiV1MasterDataContactsInteractionTypesGet<
  TData = Awaited<
    ReturnType<
      typeof listInteractionTypesApiV1MasterDataContactsInteractionTypesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListInteractionTypesApiV1MasterDataContactsInteractionTypesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInteractionTypesApiV1MasterDataContactsInteractionTypesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListInteractionTypesApiV1MasterDataContactsInteractionTypesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Define an interaction type (master_data module admin).
 * @summary Create Interaction Type
 */
export const createInteractionTypeApiV1MasterDataContactsInteractionTypesPost =
  (interactionTypeCreate: InteractionTypeCreate, signal?: AbortSignal) => {
    return customInstance<InteractionTypeResponse>({
      url: `/api/v1/master-data/contacts/interaction-types`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: interactionTypeCreate,
      signal
    });
  };

export const getCreateInteractionTypeApiV1MasterDataContactsInteractionTypesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createInteractionTypeApiV1MasterDataContactsInteractionTypesPost
        >
      >,
      TError,
      { data: InteractionTypeCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createInteractionTypeApiV1MasterDataContactsInteractionTypesPost
      >
    >,
    TError,
    { data: InteractionTypeCreate },
    TContext
  > => {
    const mutationKey = [
      'createInteractionTypeApiV1MasterDataContactsInteractionTypesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createInteractionTypeApiV1MasterDataContactsInteractionTypesPost
        >
      >,
      { data: InteractionTypeCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createInteractionTypeApiV1MasterDataContactsInteractionTypesPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateInteractionTypeApiV1MasterDataContactsInteractionTypesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createInteractionTypeApiV1MasterDataContactsInteractionTypesPost
      >
    >
  >;
export type CreateInteractionTypeApiV1MasterDataContactsInteractionTypesPostMutationBody =
  InteractionTypeCreate;
export type CreateInteractionTypeApiV1MasterDataContactsInteractionTypesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Interaction Type
 */
export const useCreateInteractionTypeApiV1MasterDataContactsInteractionTypesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createInteractionTypeApiV1MasterDataContactsInteractionTypesPost
          >
        >,
        TError,
        { data: InteractionTypeCreate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createInteractionTypeApiV1MasterDataContactsInteractionTypesPost
      >
    >,
    TError,
    { data: InteractionTypeCreate },
    TContext
  > => {
    const mutationOptions =
      getCreateInteractionTypeApiV1MasterDataContactsInteractionTypesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * One interaction type.
 * @summary Get Interaction Type
 */
export const getInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet =
  (typeId: string, signal?: AbortSignal) => {
    return customInstance<InteractionTypeResponse>({
      url: `/api/v1/master-data/contacts/interaction-types/${typeId}`,
      method: 'GET',
      signal
    });
  };

export const getGetInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGetQueryKey =
  (typeId?: string) => {
    return [
      `/api/v1/master-data/contacts/interaction-types/${typeId}`
    ] as const;
  };

export const getGetInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    typeId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGetQueryKey(
        typeId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet
        >
      >
    > = ({ signal }) =>
      getInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet(
        typeId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!typeId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet
      >
    >
  >;
export type GetInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGetQueryError =
  HTTPValidationError;

export function useGetInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet<
  TData = Awaited<
    ReturnType<
      typeof getInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet
    >
  >,
  TError = HTTPValidationError
>(
  typeId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet<
  TData = Awaited<
    ReturnType<
      typeof getInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet
    >
  >,
  TError = HTTPValidationError
>(
  typeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet<
  TData = Awaited<
    ReturnType<
      typeof getInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet
    >
  >,
  TError = HTTPValidationError
>(
  typeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Interaction Type
 */

export function useGetInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet<
  TData = Awaited<
    ReturnType<
      typeof getInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet
    >
  >,
  TError = HTTPValidationError
>(
  typeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdGetQueryOptions(
      typeId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Edit an interaction type (master_data module admin). The key is immutable.
 * @summary Update Interaction Type
 */
export const updateInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdPut =
  (typeId: string, interactionTypeUpdate: InteractionTypeUpdate) => {
    return customInstance<InteractionTypeResponse>({
      url: `/api/v1/master-data/contacts/interaction-types/${typeId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: interactionTypeUpdate
    });
  };

export const getUpdateInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdPut
        >
      >,
      TError,
      { typeId: string; data: InteractionTypeUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdPut
      >
    >,
    TError,
    { typeId: string; data: InteractionTypeUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdPut
        >
      >,
      { typeId: string; data: InteractionTypeUpdate }
    > = (props) => {
      const { typeId, data } = props ?? {};

      return updateInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdPut(
        typeId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdPut
      >
    >
  >;
export type UpdateInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdPutMutationBody =
  InteractionTypeUpdate;
export type UpdateInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Interaction Type
 */
export const useUpdateInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdPut
          >
        >,
        TError,
        { typeId: string; data: InteractionTypeUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdPut
      >
    >,
    TError,
    { typeId: string; data: InteractionTypeUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete an interaction type that has never been used (master_data module admin).

A type that HAS been used is refused with a 409 naming the remedy: deactivate it,
which withdraws it from the picker and leaves every logged interaction labelled.
 * @summary Delete Interaction Type
 */
export const deleteInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdDelete =
  (typeId: string) => {
    return customInstance<void>({
      url: `/api/v1/master-data/contacts/interaction-types/${typeId}`,
      method: 'DELETE'
    });
  };

export const getDeleteInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdDelete
        >
      >,
      TError,
      { typeId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdDelete
      >
    >,
    TError,
    { typeId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdDelete
        >
      >,
      { typeId: string }
    > = (props) => {
      const { typeId } = props ?? {};

      return deleteInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdDelete(
        typeId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdDelete
      >
    >
  >;

export type DeleteInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Interaction Type
 */
export const useDeleteInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdDelete
          >
        >,
        TError,
        { typeId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdDelete
      >
    >,
    TError,
    { typeId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteInteractionTypeApiV1MasterDataContactsInteractionTypesTypeIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Interactions for ONE named record, or across a named COHORT of contacts.

``organization_id`` names a cohort here, not a record — the people at that
company — so it narrows the same way the breakdown endpoint narrows by it.
An organization's OWN rows are still reachable two ways that did not change:
``/organizations/{id}/interactions``, which every per-record surface in the
product uses, and ``?subject_type=company&subject_id=<id>`` on this route.

The "name a record" guard is REPLACED here rather than removed. What it
exists to refuse is the tenant-wide dump — every call, email and meeting the
tenant has ever logged, gated by nothing but the module — and a caller
naming neither a record nor a cohort still gets that refusal. What it used to
refuse as well was the question this route now answers: "show me every
meeting we had with designers last quarter", which names no single record and
is the whole point of a cohort read.

The cohort vocabulary is the CONTACTS LIST's, resolved through the list's own
``build_contact_list_filters`` + ``filtered_contact_ids_query`` pair — so the
events here and the rows on the contacts page narrow by the same predicates,
and a user does not learn a second filter language. That pair also carries the
caller's viewable scope, so a contact they cannot see contributes no rows.
 * @summary List Interactions
 */
export const listInteractionsApiV1MasterDataContactsInteractionsGet = (
  params?: ListInteractionsApiV1MasterDataContactsInteractionsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<InteractionListResponse>({
    url: `/api/v1/master-data/contacts/interactions`,
    method: 'GET',
    params,
    signal
  });
};

export const getListInteractionsApiV1MasterDataContactsInteractionsGetQueryKey =
  (params?: ListInteractionsApiV1MasterDataContactsInteractionsGetParams) => {
    return [
      `/api/v1/master-data/contacts/interactions`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListInteractionsApiV1MasterDataContactsInteractionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listInteractionsApiV1MasterDataContactsInteractionsGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListInteractionsApiV1MasterDataContactsInteractionsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listInteractionsApiV1MasterDataContactsInteractionsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListInteractionsApiV1MasterDataContactsInteractionsGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listInteractionsApiV1MasterDataContactsInteractionsGet
        >
      >
    > = ({ signal }) =>
      listInteractionsApiV1MasterDataContactsInteractionsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listInteractionsApiV1MasterDataContactsInteractionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListInteractionsApiV1MasterDataContactsInteractionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listInteractionsApiV1MasterDataContactsInteractionsGet>
    >
  >;
export type ListInteractionsApiV1MasterDataContactsInteractionsGetQueryError =
  HTTPValidationError;

export function useListInteractionsApiV1MasterDataContactsInteractionsGet<
  TData = Awaited<
    ReturnType<typeof listInteractionsApiV1MasterDataContactsInteractionsGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListInteractionsApiV1MasterDataContactsInteractionsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInteractionsApiV1MasterDataContactsInteractionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listInteractionsApiV1MasterDataContactsInteractionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listInteractionsApiV1MasterDataContactsInteractionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListInteractionsApiV1MasterDataContactsInteractionsGet<
  TData = Awaited<
    ReturnType<typeof listInteractionsApiV1MasterDataContactsInteractionsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListInteractionsApiV1MasterDataContactsInteractionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInteractionsApiV1MasterDataContactsInteractionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listInteractionsApiV1MasterDataContactsInteractionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listInteractionsApiV1MasterDataContactsInteractionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInteractionsApiV1MasterDataContactsInteractionsGet<
  TData = Awaited<
    ReturnType<typeof listInteractionsApiV1MasterDataContactsInteractionsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListInteractionsApiV1MasterDataContactsInteractionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInteractionsApiV1MasterDataContactsInteractionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Interactions
 */

export function useListInteractionsApiV1MasterDataContactsInteractionsGet<
  TData = Awaited<
    ReturnType<typeof listInteractionsApiV1MasterDataContactsInteractionsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListInteractionsApiV1MasterDataContactsInteractionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listInteractionsApiV1MasterDataContactsInteractionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListInteractionsApiV1MasterDataContactsInteractionsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Log an interaction (a call, a meeting, an email, a note).
 * @summary Create Interaction
 */
export const createInteractionApiV1MasterDataContactsInteractionsPost = (
  interactionCreate: InteractionCreate,
  signal?: AbortSignal
) => {
  return customInstance<InteractionResponse>({
    url: `/api/v1/master-data/contacts/interactions`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: interactionCreate,
    signal
  });
};

export const getCreateInteractionApiV1MasterDataContactsInteractionsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createInteractionApiV1MasterDataContactsInteractionsPost
        >
      >,
      TError,
      { data: InteractionCreate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createInteractionApiV1MasterDataContactsInteractionsPost
      >
    >,
    TError,
    { data: InteractionCreate },
    TContext
  > => {
    const mutationKey = [
      'createInteractionApiV1MasterDataContactsInteractionsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createInteractionApiV1MasterDataContactsInteractionsPost
        >
      >,
      { data: InteractionCreate }
    > = (props) => {
      const { data } = props ?? {};

      return createInteractionApiV1MasterDataContactsInteractionsPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateInteractionApiV1MasterDataContactsInteractionsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createInteractionApiV1MasterDataContactsInteractionsPost
      >
    >
  >;
export type CreateInteractionApiV1MasterDataContactsInteractionsPostMutationBody =
  InteractionCreate;
export type CreateInteractionApiV1MasterDataContactsInteractionsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Interaction
 */
export const useCreateInteractionApiV1MasterDataContactsInteractionsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createInteractionApiV1MasterDataContactsInteractionsPost
        >
      >,
      TError,
      { data: InteractionCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createInteractionApiV1MasterDataContactsInteractionsPost>
  >,
  TError,
  { data: InteractionCreate },
  TContext
> => {
  const mutationOptions =
    getCreateInteractionApiV1MasterDataContactsInteractionsPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Per-type and per-contact totals for the SAME cohort the events list shows.

Same filter vocabulary, same builder, same scope — so the count and the
events agree by construction rather than by coincidence, which is the reason
the summary strip takes the list's own filter set too
(``docs/design-system/ui-list-pages.md`` §11).

A cohort is required with no per-record arm at all: this endpoint answers
"how much activity across this group", and a single record's own timeline is
already served by the two per-record routes below.
 * @summary Cohort Activity Breakdown
 */
export const cohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet =
  (
    params?: CohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<CohortActivityBreakdownResponse>({
      url: `/api/v1/master-data/contacts/interactions/breakdown`,
      method: 'GET',
      params,
      signal
    });
  };

export const getCohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGetQueryKey =
  (
    params?: CohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGetParams
  ) => {
    return [
      `/api/v1/master-data/contacts/interactions/breakdown`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getCohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof cohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: CohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof cohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getCohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof cohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet
        >
      >
    > = ({ signal }) =>
      cohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof cohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type CohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof cohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet
      >
    >
  >;
export type CohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGetQueryError =
  HTTPValidationError;

export function useCohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet<
  TData = Awaited<
    ReturnType<
      typeof cohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | CohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof cohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof cohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof cohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useCohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet<
  TData = Awaited<
    ReturnType<
      typeof cohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: CohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof cohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof cohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof cohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet<
  TData = Awaited<
    ReturnType<
      typeof cohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: CohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof cohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Cohort Activity Breakdown
 */

export function useCohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet<
  TData = Awaited<
    ReturnType<
      typeof cohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: CohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof cohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getCohortActivityBreakdownApiV1MasterDataContactsInteractionsBreakdownGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The interaction timeline on one contact.
 * @summary List Contact Interactions
 */
export const listContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet =
  (
    contactId: string,
    params?: ListContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<InteractionListResponse>({
      url: `/api/v1/master-data/contacts/people/${contactId}/interactions`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGetQueryKey =
  (
    contactId?: string,
    params?: ListContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGetParams
  ) => {
    return [
      `/api/v1/master-data/contacts/people/${contactId}/interactions`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet
      >
    >,
    TError = HTTPValidationError
  >(
    contactId: string,
    params?: ListContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGetQueryKey(
        contactId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet
        >
      >
    > = ({ signal }) =>
      listContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet(
        contactId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!contactId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet
      >
    >
  >;
export type ListContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGetQueryError =
  HTTPValidationError;

export function useListContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet<
  TData = Awaited<
    ReturnType<
      typeof listContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params:
    | undefined
    | ListContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet<
  TData = Awaited<
    ReturnType<
      typeof listContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params?: ListContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet<
  TData = Awaited<
    ReturnType<
      typeof listContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params?: ListContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Contact Interactions
 */

export function useListContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet<
  TData = Awaited<
    ReturnType<
      typeof listContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet
    >
  >,
  TError = HTTPValidationError
>(
  contactId: string,
  params?: ListContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListContactInteractionsApiV1MasterDataContactsPeopleContactIdInteractionsGetQueryOptions(
      contactId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The interaction timeline on one organization.
 * @summary List Organization Interactions
 */
export const listOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet =
  (
    organizationId: string,
    params?: ListOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<InteractionListResponse>({
      url: `/api/v1/master-data/contacts/organizations/${organizationId}/interactions`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGetQueryKey =
  (
    organizationId?: string,
    params?: ListOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGetParams
  ) => {
    return [
      `/api/v1/master-data/contacts/organizations/${organizationId}/interactions`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet
      >
    >,
    TError = HTTPValidationError
  >(
    organizationId: string,
    params?: ListOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGetQueryKey(
        organizationId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet
        >
      >
    > = ({ signal }) =>
      listOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet(
        organizationId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!organizationId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet
      >
    >
  >;
export type ListOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGetQueryError =
  HTTPValidationError;

export function useListOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet<
  TData = Awaited<
    ReturnType<
      typeof listOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  params:
    | undefined
    | ListOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet<
  TData = Awaited<
    ReturnType<
      typeof listOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  params?: ListOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet<
  TData = Awaited<
    ReturnType<
      typeof listOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  params?: ListOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Organization Interactions
 */

export function useListOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet<
  TData = Awaited<
    ReturnType<
      typeof listOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet
    >
  >,
  TError = HTTPValidationError
>(
  organizationId: string,
  params?: ListOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListOrganizationInteractionsApiV1MasterDataContactsOrganizationsOrganizationIdInteractionsGetQueryOptions(
      organizationId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Edit a manually-logged interaction (creator or admin only).
 * @summary Update Interaction
 */
export const updateInteractionApiV1MasterDataContactsInteractionsInteractionIdPut =
  (interactionId: string, interactionUpdate: InteractionUpdate) => {
    return customInstance<InteractionResponse>({
      url: `/api/v1/master-data/contacts/interactions/${interactionId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: interactionUpdate
    });
  };

export const getUpdateInteractionApiV1MasterDataContactsInteractionsInteractionIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateInteractionApiV1MasterDataContactsInteractionsInteractionIdPut
        >
      >,
      TError,
      { interactionId: string; data: InteractionUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateInteractionApiV1MasterDataContactsInteractionsInteractionIdPut
      >
    >,
    TError,
    { interactionId: string; data: InteractionUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateInteractionApiV1MasterDataContactsInteractionsInteractionIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateInteractionApiV1MasterDataContactsInteractionsInteractionIdPut
        >
      >,
      { interactionId: string; data: InteractionUpdate }
    > = (props) => {
      const { interactionId, data } = props ?? {};

      return updateInteractionApiV1MasterDataContactsInteractionsInteractionIdPut(
        interactionId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateInteractionApiV1MasterDataContactsInteractionsInteractionIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateInteractionApiV1MasterDataContactsInteractionsInteractionIdPut
      >
    >
  >;
export type UpdateInteractionApiV1MasterDataContactsInteractionsInteractionIdPutMutationBody =
  InteractionUpdate;
export type UpdateInteractionApiV1MasterDataContactsInteractionsInteractionIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Interaction
 */
export const useUpdateInteractionApiV1MasterDataContactsInteractionsInteractionIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateInteractionApiV1MasterDataContactsInteractionsInteractionIdPut
          >
        >,
        TError,
        { interactionId: string; data: InteractionUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateInteractionApiV1MasterDataContactsInteractionsInteractionIdPut
      >
    >,
    TError,
    { interactionId: string; data: InteractionUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateInteractionApiV1MasterDataContactsInteractionsInteractionIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete an interaction (creator or admin only).
 * @summary Delete Interaction
 */
export const deleteInteractionApiV1MasterDataContactsInteractionsInteractionIdDelete =
  (interactionId: string) => {
    return customInstance<void>({
      url: `/api/v1/master-data/contacts/interactions/${interactionId}`,
      method: 'DELETE'
    });
  };

export const getDeleteInteractionApiV1MasterDataContactsInteractionsInteractionIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteInteractionApiV1MasterDataContactsInteractionsInteractionIdDelete
        >
      >,
      TError,
      { interactionId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteInteractionApiV1MasterDataContactsInteractionsInteractionIdDelete
      >
    >,
    TError,
    { interactionId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteInteractionApiV1MasterDataContactsInteractionsInteractionIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteInteractionApiV1MasterDataContactsInteractionsInteractionIdDelete
        >
      >,
      { interactionId: string }
    > = (props) => {
      const { interactionId } = props ?? {};

      return deleteInteractionApiV1MasterDataContactsInteractionsInteractionIdDelete(
        interactionId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteInteractionApiV1MasterDataContactsInteractionsInteractionIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteInteractionApiV1MasterDataContactsInteractionsInteractionIdDelete
      >
    >
  >;

export type DeleteInteractionApiV1MasterDataContactsInteractionsInteractionIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Interaction
 */
export const useDeleteInteractionApiV1MasterDataContactsInteractionsInteractionIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteInteractionApiV1MasterDataContactsInteractionsInteractionIdDelete
          >
        >,
        TError,
        { interactionId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteInteractionApiV1MasterDataContactsInteractionsInteractionIdDelete
      >
    >,
    TError,
    { interactionId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteInteractionApiV1MasterDataContactsInteractionsInteractionIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * What the apply WOULD do — resolved through the apply's own resolver.

Counts only. A preview that named the contacts would be a way to enumerate
records the caller cannot open, which is the thing the editor floor above
exists to stop.
 * @summary Preview Bulk Log Interaction
 */
export const previewBulkLogInteractionApiV1MasterDataContactsInteractionsBulkPreviewPost =
  (
    bulkLogInteractionRequest: BulkLogInteractionRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<BulkLogInteractionPreview>({
      url: `/api/v1/master-data/contacts/interactions/bulk/preview`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: bulkLogInteractionRequest,
      signal
    });
  };

export const getPreviewBulkLogInteractionApiV1MasterDataContactsInteractionsBulkPreviewPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof previewBulkLogInteractionApiV1MasterDataContactsInteractionsBulkPreviewPost
        >
      >,
      TError,
      { data: BulkLogInteractionRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof previewBulkLogInteractionApiV1MasterDataContactsInteractionsBulkPreviewPost
      >
    >,
    TError,
    { data: BulkLogInteractionRequest },
    TContext
  > => {
    const mutationKey = [
      'previewBulkLogInteractionApiV1MasterDataContactsInteractionsBulkPreviewPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof previewBulkLogInteractionApiV1MasterDataContactsInteractionsBulkPreviewPost
        >
      >,
      { data: BulkLogInteractionRequest }
    > = (props) => {
      const { data } = props ?? {};

      return previewBulkLogInteractionApiV1MasterDataContactsInteractionsBulkPreviewPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PreviewBulkLogInteractionApiV1MasterDataContactsInteractionsBulkPreviewPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof previewBulkLogInteractionApiV1MasterDataContactsInteractionsBulkPreviewPost
      >
    >
  >;
export type PreviewBulkLogInteractionApiV1MasterDataContactsInteractionsBulkPreviewPostMutationBody =
  BulkLogInteractionRequest;
export type PreviewBulkLogInteractionApiV1MasterDataContactsInteractionsBulkPreviewPostMutationError =
  HTTPValidationError;

/**
 * @summary Preview Bulk Log Interaction
 */
export const usePreviewBulkLogInteractionApiV1MasterDataContactsInteractionsBulkPreviewPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof previewBulkLogInteractionApiV1MasterDataContactsInteractionsBulkPreviewPost
          >
        >,
        TError,
        { data: BulkLogInteractionRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof previewBulkLogInteractionApiV1MasterDataContactsInteractionsBulkPreviewPost
      >
    >,
    TError,
    { data: BulkLogInteractionRequest },
    TContext
  > => {
    const mutationOptions =
      getPreviewBulkLogInteractionApiV1MasterDataContactsInteractionsBulkPreviewPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Log one activity against many contacts — one interaction each.

The job this exists for is the tenant's OWN activity: a gift mailed to every
architect on a list, logged once from the activity page rather than a contact
at a time. Each contact gets its own row, so each contact's timeline carries
it and each contact's gone-quiet clock moves — a single row with many
participants would put the event on one person's timeline and leave the rest
reading off somebody else's.
 * @summary Bulk Log Interaction
 */
export const bulkLogInteractionApiV1MasterDataContactsInteractionsBulkPost = (
  bulkLogInteractionRequest: BulkLogInteractionRequest,
  signal?: AbortSignal
) => {
  return customInstance<BulkLogInteractionResponse>({
    url: `/api/v1/master-data/contacts/interactions/bulk`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkLogInteractionRequest,
    signal
  });
};

export const getBulkLogInteractionApiV1MasterDataContactsInteractionsBulkPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof bulkLogInteractionApiV1MasterDataContactsInteractionsBulkPost
        >
      >,
      TError,
      { data: BulkLogInteractionRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof bulkLogInteractionApiV1MasterDataContactsInteractionsBulkPost
      >
    >,
    TError,
    { data: BulkLogInteractionRequest },
    TContext
  > => {
    const mutationKey = [
      'bulkLogInteractionApiV1MasterDataContactsInteractionsBulkPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof bulkLogInteractionApiV1MasterDataContactsInteractionsBulkPost
        >
      >,
      { data: BulkLogInteractionRequest }
    > = (props) => {
      const { data } = props ?? {};

      return bulkLogInteractionApiV1MasterDataContactsInteractionsBulkPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkLogInteractionApiV1MasterDataContactsInteractionsBulkPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof bulkLogInteractionApiV1MasterDataContactsInteractionsBulkPost
      >
    >
  >;
export type BulkLogInteractionApiV1MasterDataContactsInteractionsBulkPostMutationBody =
  BulkLogInteractionRequest;
export type BulkLogInteractionApiV1MasterDataContactsInteractionsBulkPostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Log Interaction
 */
export const useBulkLogInteractionApiV1MasterDataContactsInteractionsBulkPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof bulkLogInteractionApiV1MasterDataContactsInteractionsBulkPost
          >
        >,
        TError,
        { data: BulkLogInteractionRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof bulkLogInteractionApiV1MasterDataContactsInteractionsBulkPost
      >
    >,
    TError,
    { data: BulkLogInteractionRequest },
    TContext
  > => {
    const mutationOptions =
      getBulkLogInteractionApiV1MasterDataContactsInteractionsBulkPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
